var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { t } from 'i18next';
import _ from 'lodash';
import { livequeueConsultationService, scheduledAppointmentsService } from 'ziphy-web-shared/basic/api';
import { useLoader } from 'ziphy-web-shared/basic/hooks';
import { ProgressRing } from 'ziphy-web-shared/basic/lib/loaders';
import { formatDate } from 'ziphy-web-shared/basic/utils/time';
import TimeSlotPicker from '@nedoShared/features/scheduledAppointments/timeSlotPicker/TimeSlotPicker';
import { Button } from '@booking/pages/liveqHome/liveqSteps/components/button';
import { ProviderItem } from '@booking/pages/liveqHome/liveqSteps/components/forms/scheduleStep/bookingStep';
import styles from '../index.module.scss';
import { $router } from 'ziphy-web-shared/basic/utils/router';
const defaultWindow = {
    key: null,
    value: [],
};
export const ProviderSelect = ({ onChangeStep = (_) => { } }) => {
    const { consultationId } = useParams();
    const [providers, setProviders] = useState();
    const [selectedWindow, setSelectedWindow] = useState(defaultWindow);
    const { isLoading } = useLoader(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const response = yield scheduledAppointmentsService.statProviders({ liveq_id: consultationId });
        setProviders((_b = (_a = response.preparedValue) === null || _a === void 0 ? void 0 : _a.providers) === null || _b === void 0 ? void 0 : _b.items);
    }));
    const [isBooking, setIsBooking] = useState(false);
    const book = () => __awaiter(void 0, void 0, void 0, function* () {
        setIsBooking(true);
        try {
            const response = yield scheduledAppointmentsService.create({ liveq_id: consultationId, provider_role_id: selectedProvider.role_id, start: `$datetime:${selectedWindow.key}` });
            const res = yield livequeueConsultationService.getConsultationById(consultationId);
            const chatId = res.chat_id;
            $router.executeAutoTarget({ to: `/orders/${consultationId}/chat/${chatId}` }, { type: 'replace' });
        }
        catch (e) {
        }
        setTimeout(() => setIsBooking(false), 1000);
    });
    const [selectedProvider, setSelectedProvider] = useState();
    const changeProvider = (provider) => {
        setSelectedProvider(provider);
        setSelectedWindow(defaultWindow);
    };
    const changeSlot = (window, list) => {
        setSelectedWindow(window);
    };
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const requestParams = useMemo(() => {
        const result = {
            liveq_id: consultationId,
            timezone: timezone,
            provider_role_id: selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.role_id,
        };
        return result;
    }, [selectedProvider]);
    useEffect(() => {
        let i = 0;
        if (selectedProvider) {
            i++;
        }
        if (selectedWindow.key) {
            i++;
            i++;
        }
        onChangeStep(i);
    }, [selectedProvider, selectedWindow]);
    return (_jsxs(_Fragment, { children: [isLoading && (_jsx("div", Object.assign({ className: styles.loading }, { children: _jsx(ProgressRing, { progress: 25, spin: true, className: '' }) }))), !isLoading && (providers === null || providers === void 0 ? void 0 : providers.length) > 0 && (_jsxs(_Fragment, { children: [_jsx("div", Object.assign({ className: styles.providersLabel }, { children: "Provider" })), _jsx("div", Object.assign({ className: styles.providers }, { children: providers.map((provider) => _jsx(ProviderItem, { isSelected: provider.id === (selectedProvider === null || selectedProvider === void 0 ? void 0 : selectedProvider.role_id), item: { name: provider.name.replace(/\u00A0/g, ' '), role: 'provider', role_id: provider.id }, onChange: changeProvider }, provider.id)) }))] })), !isLoading && selectedProvider && (_jsxs("div", Object.assign({ className: styles.schedule }, { children: [_jsx("div", Object.assign({ className: styles.scheduleLabel }, { children: "Visit Date" })), _jsx(TimeSlotPicker, { value: selectedWindow, onChange: changeSlot, 
                        // @ts-ignore
                        requestParams: requestParams, placeTimezone: timezone })] }), selectedProvider.role_id)), (selectedWindow === null || selectedWindow === void 0 ? void 0 : selectedWindow.key) && _jsx(Button, { loading: isBooking, onClick: book, label: _.isEmpty(selectedWindow)
                    ? t('btn.select_time_slot')
                    : formatDate(selectedWindow.key, {
                        format: 'datetimeFullNoYear',
                        timezone: timezone,
                    }) })] }));
};
